// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresAssigneeListBody = {
  poolId: string;
  gridId: string;
  searchQuery?: string | null;
};

export type typeSquaresAssigneeListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    guests: {
      guestId: string;
      displayName: string;
      initials: string;
      squareCount: number;
      isAtLimit: boolean;
      isAddedByViewer: boolean;
    }[];
    members: {
      userId: string;
      displayName: string;
      initials: string;
      squareCount: number;
      isAtLimit: boolean;
      isViewer: boolean;
    }[];
    maxPerMember?: number | null;
    totalMemberCount: number;
  };
};

export type typeSquaresAssigneeListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresAssigneeListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresAssigneeListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresAssigneeListBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
    searchQuery: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "gridId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresAssigneeList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresAssigneeListBody);
  }

  return async function postSquaresAssigneeList(
    payload: typeSquaresAssigneeListBody,
  ): Promise<
    typeSquaresAssigneeListOutput200 | typeSquaresAssigneeListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresAssigneeList" failed before calling the network. #b0da19b01264`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b0da19b01264" },
        },
        data: null,
      } as typeSquaresAssigneeListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/assignee-list`,
      httpMethod: "POST",
      options,
    })) as typeSquaresAssigneeListOutput200 | typeSquaresAssigneeListOutput400;
  };
}
